var defaultConfig = {
  imageSrc: '',
  film: [],
  gallery: [],
  audio: [],
  interactive: [],
  images: [],
  rectangle: [],
  file: [],
  url: [],
  games: [],
  scratch: [],
  presentation: [],
  scratchPad: [],
  number: '',
  karaoke: [],
  python: [],
};

// export const LEFT = 82;
// export const RIGHT = 1730;
// export const RIGHT = 100;
export const LEFT = 0;
export const RIGHT = 400;
export default defaultConfig;
